import { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Styles from './style.module.scss';
import withComponentName from '../../../../../../../../decorators/withComponentName';
import PricingPlansButton from './PricingPlansButton';
import windowWidthDecorator from '../../../../../../../../decorators/windowWidthDecorator';

const cx = classNames.bind(Styles);

export const PricingPlansTableHeader = (props) => {
  const {
    activePlanTab, headerCells, windowWidth, scrolling,
  } = props;

  const [activePlanButton, setActivePlanButton] = useState('annually');
  const [scroll, setScroll] = useState(0);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  const handleButtonClick = (selectedPlan) => {
    setActivePlanButton(selectedPlan);
  };

  useEffect(() => {
    setScroll(window.scrollY);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const formatPrice = (price) => price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  if (activePlanButton === 'semiAnnually' && activePlanTab === 'commercial') {
    setActivePlanButton('quarterly');
  } else if (activePlanButton === 'quarterly' && activePlanTab === 'noncommercial') {
    setActivePlanButton('semiAnnually');
  }

  const headerWithoutImg = ((scroll > 670) && ((windowWidth > 960) && (windowWidth < 1024) && (activePlanTab === 'noncommercial')))
  || ((scroll > 670) && ((windowWidth < 2800) && (windowWidth > 1110) && (activePlanTab === 'noncommercial')))
  || ((scroll > 670) && ((windowWidth < 2800) && (windowWidth > 1370) && (activePlanTab === 'commercial')))
  || ((scroll > 1350) && (windowWidth >= 2800))
  || scrolling;

  return (
    <thead>
      <tr>
        <th id="tableHeader" className={cx('tableHeader', activePlanTab, { '--not-image': headerWithoutImg })}>
          <div className={cx('PricingPlans__note')}>
            Taxes will be added where applicable.
            {' '}
            <br />
            All prices are in United States Dollars.
          </div>
        </th>
        {headerCells.filter((cell) => cell.planType === activePlanTab)
          .map((cells) => cells.plans
            .map((cell, index) => (
              <th key={cell.id} className={cx('tableHeader', activePlanTab, { '--not-image': headerWithoutImg })}>
                <div className={cx('tableHeader__content')}>
                  <div className={cx('logo', activePlanTab, { [`logo--${index}`]: true })}>
                    <img src={cell.logo} alt={cell.id} />
                  </div>
                  <div className={cx('title')}>{cell.value}</div>
                </div>
              </th>
            )))}
      </tr>
      <tr>
        <th className={cx('tableHeader', activePlanTab, 'header__buttons', { '--not-image': headerWithoutImg })}>
          <div className={cx('PricingPlans')}>
            <div className={cx('PricingPlans__title')}>Price:</div>
            <div className={cx('PricingPlans__buttons')}>
              <PricingPlansButton
                btnID={activePlanTab === 'commercial' ? 'quarterly' : 'semiAnnually'}
                btnText={activePlanTab === 'commercial' ? 'Quarterly' : 'Semi-Annually'}
                isActive={activePlanTab === 'commercial' ? activePlanButton === 'quarterly' : activePlanButton === 'semiAnnually'}
                handleBtnClick={() => handleButtonClick(activePlanTab === 'commercial' ? 'quarterly' : 'semiAnnually')}
                activePlanTab={activePlanTab}
              />
              <PricingPlansButton
                btnID="annually"
                btnText="Annually"
                isActive={activePlanButton === 'annually'}
                handleBtnClick={() => handleButtonClick('annually')}
                activePlanTab={activePlanTab}
              />
            </div>
          </div>
        </th>
        {headerCells.filter((cell) => cell.planType === activePlanTab)
          .map((cells) => cells.plans
            .map((cell) => (
              <th key={cell.id} className={cx('tableHeader', activePlanTab, 'price_cell', { '--not-image': headerWithoutImg })}>
                <div className={cx('plan__container')}>
                  {cell.plans.filter((el) => (el.period === activePlanButton))
                    .map((tab) => (
                      <div key={tab.period}>
                        <div className={cx('priceMonthly')}>
                          {tab.priceMonthly
                            && `$
                          ${formatPrice(+tab.priceMonthly)}
                          US/mo`}
                          {tab.price && tab.price}
                        </div>
                        {tab.priceMonthly && (
                          <div className={cx('totalPrice')}>
                            {tab.period === 'quarterly'
                              && `Billed at $
                              ${formatPrice(3 * +tab.priceMonthly)}
                              US`}
                            {tab.period === 'semiAnnually'
                              && `Billed at $
                              ${formatPrice(6 * +tab.priceMonthly)}
                              US`}
                            {tab.period === 'annually'
                              && `Billed at $
                              ${formatPrice(12 * +tab.priceMonthly)}
                              US`}
                          </div>
                        )}
                        {tab.isComingSoon && (
                          <div key={tab.id} className={cx('coming-soon__container')}>
                            <div className={cx('coming-soon')}>Coming Soon</div>
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </th>
            )))}
      </tr>
    </thead>
  );
};

PricingPlansTableHeader.propTypes = {
  activePlanTab: PropTypes.string.isRequired,
  headerCells: PropTypes.instanceOf(Array).isRequired,
};

export default withComponentName(windowWidthDecorator(PricingPlansTableHeader));
